module.exports = __webpack_public_path__ + "img/scop3.f3b25714.jpg";